import { Routes, Route, Navigate, useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { SolutionSearch } from './components/SolutionSearch';
import { AppShell } from './components/AppShell';
import { ToolboxProvider } from './context/ToolboxContext';
import { ChatProvider } from './context/ChatContext';
import { TabProvider, useTabs } from './context/TabContext';
import { WorkflowsProvider } from './context/WorkflowsContext';
import { ModeProvider } from './context/ModeContext';
import { AssistantProvider } from './context/AssistantContext';
import { KnowledgeBaseProvider } from './context/KnowledgeBaseContext';
import { CatalogProvider } from './context/CatalogContext';
import { getToolById } from './data/tools';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Workflows } from './pages/Workflows';
import { Assistants } from './pages/Assistants';
import { Upload } from './pages/Upload';
import { Admin } from './pages/Admin';

// Handle /tools/:toolId route - opens tool in tab
function ToolRouteHandler() {
  const { toolId } = useParams<{ toolId: string }>();
  const navigate = useNavigate();
  const { openToolTab } = useTabs();

  useEffect(() => {
    if (toolId) {
      const tool = getToolById(toolId);
      if (tool) {
        openToolTab(toolId, tool.name);
      }
      // Redirect to home after opening tab
      navigate('/', { replace: true });
    }
  }, [toolId, openToolTab, navigate]);

  return null;
}

function AppContent() {
  return (
    <AppShell>
      <ErrorBoundary>
      <Routes>
        <Route path="/" element={<SolutionSearch />} />
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/assistants" element={<Assistants />} />
        <Route path="/train" element={<Navigate to="/assistants" replace />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/tools/:toolId" element={<ToolRouteHandler />} />
      </Routes>
      </ErrorBoundary>
    </AppShell>
  );
}

function App() {
  return (
    <ModeProvider>
      <CatalogProvider>
      <KnowledgeBaseProvider>
      <AssistantProvider>
        <ToolboxProvider>
          <ChatProvider>
            <WorkflowsProvider>
              <TabProvider>
                <AppContent />
              </TabProvider>
            </WorkflowsProvider>
          </ChatProvider>
        </ToolboxProvider>
      </AssistantProvider>
      </KnowledgeBaseProvider>
      </CatalogProvider>
    </ModeProvider>
  );
}

export default App;
